export default "__VITE_ASSET__046d1938__"